import React from "react";

/**
 * Top-level error boundary. Catches DOM-reconciliation crashes (notably the
 * React-19 + Radix-portal `removeChild` NotFoundError) so a stray overlay
 * cannot take the whole app down. Falls back to a translated-ish blank
 * card with a Reload button; hard-refresh always works.
 *
 * NOT a replacement for fixing the underlying race — just a backstop.
 */
export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[AppErrorBoundary]", error, info?.componentStack);
  }

  handleReload = () => {
    // Full reload — safest recovery from a torn-portal state.
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-offwhite px-4"
        data-testid="app-error-boundary"
      >
        <div className="w-full max-w-md rounded-lg border border-border-subtle bg-surface p-6 text-center shadow-card">
          <h1 className="text-lg font-semibold text-text-primary">Etwas ist schiefgelaufen.</h1>
          <p className="mt-2 text-sm text-text-secondary">
            Die Seite konnte nicht wiederhergestellt werden. Bitte neu laden.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            data-testid="app-error-reload"
            className="mt-6 inline-flex items-center rounded-md bg-charcoal px-4 py-2 text-sm font-medium text-white hover:bg-charcoal-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne"
          >
            Seite neu laden
          </button>
        </div>
      </div>
    );
  }
}
